/**
 * The privacy policy as a plain page, reachable without an account.
 *
 * Linked from onboarding and from "Ti", because a consent people cannot read
 * afterwards is not much of a consent.
 */

import { PRIVACY_DOCUMENT, PRIVACY_VERSION } from '../content/privacy.js'

export function renderPrivacy(root, { onBack }) {
  root.innerHTML = `
    <article>
      <button class="link-button" id="back">← Back</button>
      <h1 class="brief__title">${PRIVACY_DOCUMENT.title}</h1>
      <p class="screen-head__meta">${PRIVACY_DOCUMENT.updated} · version ${PRIVACY_VERSION}</p>

      <div class="prose">
        ${PRIVACY_DOCUMENT.sections
          .map(
            (section) => `
          <h2>${section.heading}</h2>
          <ul>${section.body.map((line) => `<li>${line}</li>`).join('')}</ul>
        `,
          )
          .join('')}
      </div>
    </article>
  `

  root.querySelector('#back').addEventListener('click', onBack)
}
